import { useState, forwardRef } from 'react';
import omit from 'lodash/omit';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';

import TogglePasswordIconButton from 'components/TogglePasswordIconButton';

const PasswordTextField = forwardRef<typeof TextField, TextFieldProps>(
  ({ ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    return (
      <TextField
        inputRef={ref}
        label={props.label || 'Password'}
        type={showPassword ? 'text' : 'password'}
        id="password"
        autoComplete="current-password"
        InputProps={{
          endAdornment: (
            <TogglePasswordIconButton
              showPassword={showPassword}
              setShowPassword={setShowPassword}
            />
          ),
          ...props.InputProps,
        }}
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...omit(props, ['InputProps'])}
      />
    );
  }
);

export default PasswordTextField;
